import React from 'react';
import Draggable from 'react-draggable';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import Kruis from '../Icons/Kruis';

import './Editor.css';

const Editor = (props) => {

	const thisClass = (props.status === 'closed') ? 'editor closed' : 'editor open';
	const id = props.player ? props.player.id : undefined;
	const name = props.player ? props.player.name : '';
	const size = props.player ? props.player.size : 5;
	const Handle = Slider.Handle;

	const handle = (props) => {
	  const { value, dragging, index, ...restProps } = props;
	  return (
	    <Tooltip
	      prefixCls="rc-slider-tooltip"
	      overlay={value}
	      visible={dragging}
	      placement="top"
	      key={index}
	    >
	      <Handle value={value} {...restProps} />
	    </Tooltip>
	  );
	};

	return (
		<Draggable
			handle='.editor-title'
			bounds='parent'
		>
	  <div className={thisClass}>
	  	<h4 className='editor-title'>Speler
	  		<button className='editor-close' onClick={props.handleCloseEditor}><Kruis /></button>
  		</h4>
  		<div className='editor-content'>

  			<input className='editor-name' type='text'
  				placeholder='Naam'
  				value={name}
  				onChange={(event) => props.handleChangeName(id, event.target.value)}
  			/>

  			<Slider
  				min={1}
  				max={10}
  				step={1}
  				value={size}
  				handle={handle}
  				onChange={(value) => props.handleChangeSize(id, value)}
				/>

  			<div className='editor-colorpicker'>
  					<span onClick={() => props.handleChangeColor(id, 0)} className='pick color0'></span>
  					<span onClick={() => props.handleChangeColor(id, 1)} className='pick color1'></span>
  					<span onClick={() => props.handleChangeColor(id, 2)} className='pick color2'></span>
  					<span onClick={() => props.handleChangeColor(id, 3)} className='pick color3'></span>
  					<span onClick={() => props.handleChangeColor(id, 4)} className='pick color4'></span>
  					<span onClick={() => props.handleChangeColor(id, 5)} className='pick color5'></span>
  					<span onClick={() => props.handleChangeColor(id, 6)} className='pick color6'></span>
  					<span onClick={() => props.handleChangeColor(id, 7)} className='pick color7'></span>
  			</div>

  			<button className='editor-delete' onClick={() => props.handleDeletePlayer(id)}>Verwijder speler</button>

  		</div>
	  </div>
	  </Draggable>
	)
}

export default Editor;



// WEBPACK FOOTER //
// ./src/components/Editor/Editor.js